import { render } from "./SecretSelector.vue?vue&type=template&id=64c2a2b6"
import script from "./SecretSelector.vue?vue&type=script&lang=js"
export * from "./SecretSelector.vue?vue&type=script&lang=js"

import "./SecretSelector.vue?vue&type=style&index=0&id=64c2a2b6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__